<div *ngIf="show" class="layout-mask modal-in flex justify-content-center align-items-center">
  <app-spinner [inline]="true"></app-spinner>
</div>
